
    <template>
      <section class="doc-article monkey-view-doc">
        <h1>Time 相对时间</h1>
<h2 id="dai-ma-shi-li" class="anchor-title">代码示例 <a class="header-anchor" href="#dai-ma-shi-li">#</a></h2>
<code-wrap id="JCYF">
                <template slot="description"><p>默认类型时，一分钟之内显示为（..秒前），一小时之内显示（..分钟前），今天显示（时间点），昨天显示（昨天+时间点），昨天之前显示（时间点）</p>
</template>
                <template slot="title">基础用法 <a href="#JCYF" data-title="基础用法">#</a></template>
                <template slot="source"><monkey-view-demo0 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;h4&gt;指定时间在当前时间点之前&lt;/h4&gt;
    一分钟之内：&lt;Time :time=&quot;baseTime1&quot;&gt;&lt;/Time&gt;
    &lt;br&gt;
    一小时之内：&lt;Time :time=&quot;baseTime2&quot;&gt;&lt;/Time&gt;
    &lt;br&gt;
    今天：&lt;Time :time=&quot;baseTime3&quot;&gt;&lt;/Time&gt;
    &lt;br&gt;
    昨天：&lt;Time :time=&quot;baseTime4&quot;&gt;&lt;/Time&gt;
    &lt;br&gt;
    昨天之前：&lt;Time :time=&quot;baseTime5&quot;&gt;&lt;/Time&gt;

    &lt;h4&gt;指定时间在当前时间点之后&lt;/h4&gt;
    一分钟之内：&lt;Time :time=&quot;baseTime6&quot;&gt;&lt;/Time&gt;
    &lt;br&gt;
    一小时之内：&lt;Time :time=&quot;baseTime7&quot;&gt;&lt;/Time&gt;
    &lt;br&gt;
    今天：&lt;Time :time=&quot;baseTime8&quot;&gt;&lt;/Time&gt;
    &lt;br&gt;
    明天：&lt;Time :time=&quot;baseTime9&quot;&gt;&lt;/Time&gt;
    &lt;br&gt;
    明天之后：&lt;Time :time=&quot;baseTime10&quot;&gt;&lt;/Time&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        let date = new Date();
        let yesterDate = new Date();
        yesterDate.setDate(date.getDate() - 1);
        let oldDate = new Date();
        oldDate.setDate(date.getDate() - 2);
        return {
          baseTime1: date - 10 * 1000,
          baseTime2: date - 60 * 45 * 1000,
          baseTime3: date - 60 * 70 * 1000,
          baseTime4: yesterDate,
          baseTime5: oldDate,

          baseTime6: date.getTime() + 10 * 1000,
          baseTime7: date.getTime() + 60 * 45 * 1000,
          baseTime8: date.getTime() + 2 * 60 * 60 * 1000,
          baseTime9: date.getTime() + 24 * 60 * 60 * 1000,
          baseTime10: date.getTime() + 48 * 60 * 60 * 1000,
        }
      }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="LX">
                <template slot="description"><p>type类型可取值<code>relative</code> <code>date</code> <code>datetime</code></p>
</template>
                <template slot="title">type类型 <a href="#LX" data-title="type类型">#</a></template>
                <template slot="source"><monkey-view-demo1 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Time :time=&quot;baseTime&quot;&gt;&lt;/Time&gt;
    &lt;br&gt;
    &lt;Time :time=&quot;baseTime&quot; type=&quot;date&quot;&gt;&lt;/Time&gt;
    &lt;br&gt;
    &lt;Time :time=&quot;baseTime&quot; type=&quot;datetime&quot;&gt;&lt;/Time&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        let date = new Date();
        return {
          baseTime: date - 10 * 1000,
        }
      }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="GSH">
                <template slot="description"><p>format默认<code>yyyy-MM-dd hh:mm:ss</code></p>
</template>
                <template slot="title">format格式化 <a href="#GSH" data-title="format格式化">#</a></template>
                <template slot="source"><monkey-view-demo2 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Time :time=&quot;baseTime&quot; format=&quot;yyyy年MM月dd日 hh:mm&quot;&gt;&lt;/Time&gt;
    &lt;br&gt;
    &lt;Time :time=&quot;baseTime2&quot; format=&quot;yyyy年MM月dd日 hh:mm&quot;&gt;&lt;/Time&gt;
    &lt;br&gt;
    &lt;Time :time=&quot;baseTime&quot; type=&quot;date&quot; format=&quot;yyyy年MM月dd日 hh:mm&quot;&gt;&lt;/Time&gt;
    &lt;br&gt;
    &lt;Time :time=&quot;baseTime&quot; type=&quot;datetime&quot; format=&quot;yyyy年MM月dd日 hh:mm&quot;&gt;&lt;/Time&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        let date = new Date();
        return {
          baseTime: date - 10 * 1000,
          baseTime2: date - 24 * 60 * 60 * 1000,
        }
      }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<code-wrap id="ZDGXSJ">
                <template slot="description"><p><code>interval</code>属性设置自动更新时间的间隔，单位：秒。</p>
</template>
                <template slot="title">自动更新时间 <a href="#ZDGXSJ" data-title="自动更新时间">#</a></template>
                <template slot="source"><monkey-view-demo3 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Time :time=&quot;baseTime&quot; :interval=&quot;1&quot;&gt;&lt;/Time&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          baseTime: new Date()
        }
      }
    }
&lt;/script&gt;
</code></pre></div></template></code-wrap>
<h2 id="api" class="anchor-title">API <a class="header-anchor" href="#api">#</a></h2>
<h3 id="time-props" class="anchor-title">Time props <a class="header-anchor" href="#time-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>time</td>
<td>String、Date、Number</td>
<td>必传参数，支持时间戳</td>
<td>-</td>
</tr>
<tr>
<td>type</td>
<td>String</td>
<td><code>relative</code> <code>date</code> <code>datetime</code>,<code>relative</code>类型时，默认一分钟之内显示为（..秒前），一小时之内显示（..分钟前），今天显示（时间点），昨天显示（昨天+时间点），昨天之前显示（时间点）</td>
<td>relative</td>
</tr>
<tr>
<td>interval</td>
<td>Number</td>
<td>设置自动更新时间的间隔，单位：秒</td>
<td>-</td>
</tr>
<tr>
<td>format</td>
<td>String</td>
<td>格式化时间显示，<code>date</code> <code>datetime</code>时有效，<code>relative</code>时按照指定的时间格式显示日期和时间</td>
<td>yyyy-MM-dd hh:mm:ss</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "monkey-view-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('h4',[_vm._v("指定时间在当前时间点之前")]),_vm._v("\n    一分钟之内："),_c('Time',{attrs:{"time":_vm.baseTime1}}),_vm._v(" "),_c('br'),_vm._v("\n    一小时之内："),_c('Time',{attrs:{"time":_vm.baseTime2}}),_vm._v(" "),_c('br'),_vm._v("\n    今天："),_c('Time',{attrs:{"time":_vm.baseTime3}}),_vm._v(" "),_c('br'),_vm._v("\n    昨天："),_c('Time',{attrs:{"time":_vm.baseTime4}}),_vm._v(" "),_c('br'),_vm._v("\n    昨天之前："),_c('Time',{attrs:{"time":_vm.baseTime5}}),_vm._v(" "),_c('h4',[_vm._v("指定时间在当前时间点之后")]),_vm._v("\n    一分钟之内："),_c('Time',{attrs:{"time":_vm.baseTime6}}),_vm._v(" "),_c('br'),_vm._v("\n    一小时之内："),_c('Time',{attrs:{"time":_vm.baseTime7}}),_vm._v(" "),_c('br'),_vm._v("\n    今天："),_c('Time',{attrs:{"time":_vm.baseTime8}}),_vm._v(" "),_c('br'),_vm._v("\n    明天："),_c('Time',{attrs:{"time":_vm.baseTime9}}),_vm._v(" "),_c('br'),_vm._v("\n    明天之后："),_c('Time',{attrs:{"time":_vm.baseTime10}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        let date = new Date();
        let yesterDate = new Date();
        yesterDate.setDate(date.getDate() - 1);
        let oldDate = new Date();
        oldDate.setDate(date.getDate() - 2);
        return {
          baseTime1: date - 10 * 1000,
          baseTime2: date - 60 * 45 * 1000,
          baseTime3: date - 60 * 70 * 1000,
          baseTime4: yesterDate,
          baseTime5: oldDate,

          baseTime6: date.getTime() + 10 * 1000,
          baseTime7: date.getTime() + 60 * 45 * 1000,
          baseTime8: date.getTime() + 2 * 60 * 60 * 1000,
          baseTime9: date.getTime() + 24 * 60 * 60 * 1000,
          baseTime10: date.getTime() + 48 * 60 * 60 * 1000,
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Time',{attrs:{"time":_vm.baseTime}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('Time',{attrs:{"time":_vm.baseTime,"type":"date"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('Time',{attrs:{"time":_vm.baseTime,"type":"datetime"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        let date = new Date();
        return {
          baseTime: date - 10 * 1000,
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Time',{attrs:{"time":_vm.baseTime,"format":"yyyy年MM月dd日 hh:mm"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('Time',{attrs:{"time":_vm.baseTime2,"format":"yyyy年MM月dd日 hh:mm"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('Time',{attrs:{"time":_vm.baseTime,"type":"date","format":"yyyy年MM月dd日 hh:mm"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('Time',{attrs:{"time":_vm.baseTime,"type":"datetime","format":"yyyy年MM月dd日 hh:mm"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        let date = new Date();
        return {
          baseTime: date - 10 * 1000,
          baseTime2: date - 24 * 60 * 60 * 1000,
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Time',{attrs:{"time":_vm.baseTime,"interval":1}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          baseTime: new Date()
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  